<template>
  <div class="report-content-body" ref="reportContentBody" >
    <div class="row" v-if="report != null">
      <report-doc :report="report" :index="selectedReport" :id="reportId"></report-doc>
      <report-desc id="reportDesc" v-if="reportDescription" :reportDesc="reportDescription"></report-desc>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ReportDoc from '@/components/includes/report/ReportDoc';
import ReportDesc from '@/components/includes/report/ReportDesc';

export default {
  name: 'report-content-body',
  components: {
    'report-doc': ReportDoc,
    'report-desc': ReportDesc
  },
  computed: {
    pdfId() {
      return this.allData.reports[this.selectedReport].id;
    },
    ...mapGetters('login',{
      allData: 'getAllData'
    }),
    ...mapGetters('login/report',{
      reportDescriber: 'getReportDescriber'
    }),
    reportDescription() {
      return this.reportDescriber(this.selectedReport)
    }
  },
  props: {
    selectedReport: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      report: null,
    }
  },
  beforeDestroy () {
    // clean up
    delete this.report;
    this.report = null;
  },
  methods: {
    ...mapActions('login/report', [
      'requestReportById',
    ]),
    loadReport() {
      let loader = this.$loading.show({
        container: this.$refs.reportContentBody
      }, {
        after: this.$createElement('div',{},['Transfering data to pdf viewer...'])
      });
      this.requestReportById(this.pdfId)
      .then((report) => {
        this.report = report;
      })
      .catch((err) => {
        console.error(err);
        this.$swal({
          type: 'error',
          title: 'Unable to fetch the report',
          text: 'Please try again or select another report.'
        })
      }).finally( () => {
        loader.hide();
        loader = null;
      });
    },
    refresh () {
      if (this.$route.params.index === -1) {
        return;
      }
      if (this.$route.params.index !== null) {
        // display progress (spinning wheel) as a visual cue
        const index = this.$route.params.index;
        if (this.reportList && this.reportList[index] && this.reportList[index].id) {
          let loader = this.$loading.show({
            container: this.$refs.reportContentBody
          }, {
            after: this.$createElement('div',{},['Transfering data to pdf viewer...'])
          });
          const id = this.reportList[index].id;
          // update report in iframe
          this.requestReportById({id:id, index:index})
          .then((report) => {
            this.report = report;
          })
          .catch((err) => {
            console.error(err);
            this.$swal({
              type: 'error',
              title: 'Unable to fetch the report',
              text: 'Please try again or select another report.'
            })
          }).finally( () => {
            loader.hide();
            loader = null;
          });
        }
        else {
          this.$swal({
            type: 'error',
            title: `Unable to retrieve`,
            text: `The file you requested does not exist. Please choose another file.`
          })
        }
      }
    }
  },
  watch: {
    // refresh div to get report content when report id is changed in url
    '$route.params.index' (id) {
      this.refresh();
    }
  },
  created () {
    this.loadReport();
  }
}
</script>

<style scoped lang="scss">

</style>
